import React from 'react';
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TABLET_BREAKPOINT } from '../../../../Constants/constant';

const useStyles = makeStyles((theme) => ({
  li: {
    textAlign: 'left',
    padding: theme.spacing(1),
    paddingLeft: '5px',
  },
}));

const Instructions = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  return (
    <>
      <Box p={2} width={isMobileScreen ? '100%' : '80%'} margin="0 auto">
        <Typography
          fontWeight={700}
          variant="h4"
          color="primary"
          pt={3}
          align="left"
          textTransform="uppercase"
        >
          Instructions
        </Typography>
        <Box py={isMobileScreen ? 1 : 3}>
          <Divider />
        </Box>

        <Box pt={0}>
          <Typography
            fontWeight={500}
            color="primary"
            align="left"
            variant="subtitle2"
            fontSize={'20px'}
          >
            Important Notes
          </Typography>
          <ol>
            <li className={classes.li}>
              Please read the instructions carefully before filling out the
              form.
            </li>
            <li className={classes.li}>
              Make sure to fill in all the required fields marked with an
              asterisk (*).
            </li>
            <li className={classes.li}>
              The form can be saved once all fields marked with an asterisk (*)
              on a single page have been completed.
            </li>
            <li className={classes.li}>
              Use proper capitalization and spelling in all fields.
            </li>
            <li className={classes.li}>
              The maximum file size for uploads is 5 MB
            </li>
            <li className={classes.li}>
              Provide accurate and current information.
            </li>
            <li className={classes.li}>
              Do not leave any fields blank, if not applicable, please write
              N/A.
            </li>
            <li className={classes.li}>
              Once you have completed the form, please double-check for errors
              and accuracy before submitting.
            </li>
            <li className={classes.li}>
              After submission, you will not be able to edit the form.
            </li>
            <li className={classes.li}>
              Keep a copy of the filled form for your records.
            </li>
            <li className={classes.li}>
              If you have any questions or issues, please contact the form
              administrator for assistance.{' '}
            </li>
            {/* <li className={classes.li}>
              Please refer to the policy and the eligibility criteria for this
              course mentioned in the following link before you start the
              application form -{' '}
              <a
                href="https://www.spjain.org/governance-policies"
                target="_blank"
              >
                https://www.spjain.org/governance-policies
              </a>
            </li> */}
          </ol>
        </Box>

        {/* <Box>
					<Typography
						fontWeight={500}
						color='primary'
						pb={2}
						align='left'
						variant='subtitle2'
						fontSize={"20px"}
					>
						Mandatory Documents
					</Typography>
					<Typography align='left'>
						Please ensure that you possess the following documents for upload
						before continuing
					</Typography>
					<ul>
						<li className={classes.li}>Birth Certificate</li>
						<li className={classes.li}>Aadhaar Card</li>
						<li className={classes.li}>Passport</li>
						<li className={classes.li}>Provisional Certificate</li>
					</ul>
				</Box> */}
      </Box>
    </>
  );
};

export default Instructions;
